import React, { useState, useEffect } from "react";
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import { makeStyles, Box, TextField, Button, CircularProgress, Collapse } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import DeleteIcon from '../assets/icons/primary-blue-bin.png';
import { PrimaryButton } from '../common/button';
import colors from '../CustomizedUIs/Colors'
import { MuiColorInput } from 'mui-color-input';
const useStyles = makeStyles(theme => ({
    btnMetaData: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
    },
    textMetaData: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: 8
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#88898c',
        paddingLeft: '16px'
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: 'normal',
        paddingLeft: '16px'
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingLeft: '16px',
        height:'100%'
    },
}));

const MetaData = ({ value, color, textOnChange, colorOnChange , validate, onRemove }:any) => {
    const classes = useStyles();
    const translate = useTranslate();
    const [valueColor, setValueColor] = useState(color || 'rgb(0, 0, 0)')
  
    const handleChange = (newValue: any) => {
        setValueColor(newValue)
        if(colorOnChange){
            colorOnChange({prop:'color',value: newValue});
        }
    }
    return (
        <Box display='flex' borderRadius={4} bgcolor='background.paper' px={1}>
                <TextField
                    required
                    variant='filled'
                    label={translate(`pos.messages.type`)}
                    error={validate.value.isError && validate.value.message != ""}
                    helperText={validate.value.isError ? validate.value.message : ""}
                    value={value}
                    onBlur={textOnChange('value')}
                    onChange={textOnChange('value')}
                    size="small"
                    style={{ width: '200px', paddingRight: '30px' }}
                    FormHelperTextProps={{
                        className: classes.textError
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.textLabel,
                            error: classes.textLableError
                        }
                    }}
                    InputProps={{
                        className: classes.input,
                        classes: {
                            underline: validate.value.isError ? classes.underlineError : (validate.value.message !== "" ? classes.underline : classes.underlineNotValue),
                            focused: classes.focuses
                        }
                    }} />
                <MuiColorInput value={valueColor} onChange={handleChange} /><Box display='flex' justifyContent='center' mt={1}>    
            </Box>
            <IconRadiusButton
                style={{ marginLeft: 8 }}
                onClick={onRemove} border={null} borderRadius={null} bgColor={null} width='50px !important' height='50px !important'>
                <img src={DeleteIcon} width='18px' height='18px'></img>
            </IconRadiusButton>
        </Box>
    )
}

const CalendarType = () => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(false);
    const [listCalendarEvent, setListCalendarEvent] = useState([] as any);
    const [validateCalendarEvent, setValidateCalendarEvent] = useState([] as any);
    const [isSave, setIsSave] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);

    const onChangeTypeName = (index: number) => (prop: string | number) => (e: { target: { value: any; }; }) => {
        var tempArray = listCalendarEvent.slice() as any;
        tempArray[index][prop] = e.target.value
        setListCalendarEvent(tempArray)
        validateType(index)(e.target.value)(prop)
    }

    const onChangeColor = (index: number) => (e: { prop: any, value: any; }) => {
        var tempArray = listCalendarEvent.slice() as any;
        console.dir(e);
        tempArray[index][e.prop] = e.value
        setListCalendarEvent(tempArray)
    }

    const validateType = (index: number) => (value: string) => (prop: string | number) => {
        var validates = validateCalendarEvent.slice() as any;
        if (value === "") {
            validates[index][prop].isError = true
            validates[index][prop].message = "required"
        }
        else {
            const existingName = listCalendarEvent.filter((e: { value: string; }) => e.value === value);
            if(existingName && existingName.length > 1) {
                validates[index][prop].isError = true
                validates[index][prop].message = "duplication"
            }
            else {
                validates[index][prop].isError = false
                validates[index][prop].message = ""
            }
        }
        setValidateCalendarEvent(validates)
    }

    const onClickAddType = () => {
        var tempArray = listCalendarEvent.slice() as any
        var validates = validateCalendarEvent.slice() as any
        tempArray.push({
            value: "",
        })
        validates.push({
            value: { isError: true, message: "" }
        })
        setValidateCalendarEvent(validates)
        setListCalendarEvent(tempArray)
    }

    const onRemoveType = (index: number) => () => {
        if (listCalendarEvent.length > 1) {
            var tempArray = listCalendarEvent.slice()
            tempArray.splice(index, 1)
            var validates = validateCalendarEvent.slice()
            validates.splice(index, 1)
            setValidateCalendarEvent(validates)
            setListCalendarEvent(tempArray)
        }
    }

    const getListType = () => {
        setLoading(true)
        dataProvider('GET_LIST', "calendartype", {
            filter: {},
            skip:-1,
            sort: { field: 'id', order: 'ASC'},
            pagination: {}
        }).then(({ data }: any) => {
            data.map((eventType: { type: any; jsonType:any, id:any}) => {
              listCalendarEvent.push({ value: eventType.type, color: JSON.parse(eventType.jsonType).dcolor, id: eventType.id })
            })
            var validateEmails = [] as any;
            listCalendarEvent.forEach(() => {
                validateEmails.push({
                    name: {
                        isError: 'false',
                        message: ''
                    },
                    value: {
                        isError: 'false',
                        message: ''
                    }
                })
            })
            setValidateCalendarEvent(validateEmails)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        });
    }

    const handleOnSave = () => {
        console.dir(listCalendarEvent);
        setLoading(true)
        dataProvider('CREATE', 'calendartype/multiple', {
            data: { listCalendarEvent }
        }).then(({ }) => {
            setIsSave(true)
            setOpenAlert(false)
            setLoading(false)
        }).catch(() => {
            setIsSave(false)
            setOpenAlert(true)
            setLoading(false)
            // TODO: Should show error message
        });
    }

    const disableSaveButton = () => {
        if (listCalendarEvent.length === 0) return true;
        for (let i = 0; i < validateCalendarEvent.length; i++) {
            if (validateCalendarEvent[i].value.isError === true) {
                return true
            }
        }
        return false;
    }

    useEffect(() => {
        getListType()
    }, []);

    if (loading) return <Loading />
    return (
        <Box>
            <Box mt={3}>
                <Collapse in={openAlert}>
                    <Alert severity={isSave ? "success" : "error"}>{translate(`pos.auth.sendMailError`)}</Alert>
                </Collapse>
            </Box>
            <Box display="flex" padding='60px' justifyContent='center'>
                <Box>
                    <Box mr={3}>
                        <PrimaryButton
                          secondary={null}
                          style={{ width: 200 }}
                          label={translate(`pos.support.eventType`)}
                          onClick={onClickAddType} large={undefined}  
                        />
                    </Box>
                </Box>
                <Box>
                    {
                        listCalendarEvent.map((row: { value: any; color: any }, index: number) => (
                            <MetaData
                                key={index}
                                value={row.value}
                                color={row.color}
                                validate={validateCalendarEvent[index]}
                                textOnChange={onChangeTypeName(index)}
                                colorOnChange={onChangeColor(index)}
                                onRemove={onRemoveType(index)}
                            />
                        ))
                    }
                    <Box width='100%' display='flex' justifyContent='flex-end' mt={1}>
                        <Button
                            disabled={disableSaveButton()}
                            style={{ maxWidth: 40 }}
                            onClick={handleOnSave}
                            variant="contained" color='primary' size='large'>
                            {loading ? (
                                <CircularProgress
                                    size={20}
                                    thickness={2}
                                    color='inherit'
                                />
                            ) : translate('resources.room.save')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
};

export default CalendarType;